'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOURS = exports.MINUTES = exports.SECONDS = exports.MS = exports.required = exports.toss = exports.token = exports.filter = exports.nop = exports.base64Decode = exports.base64Encode = exports.getters = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _crypto = require('crypto');

var _crypto2 = _interopRequireDefault(_crypto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var get = function get(prop) {
  return function (obj) {
    return obj[prop];
  };
};

// Creates a new object copying all functions and replacing other values with
// getter functions.
var getters = exports.getters = function getters(kvs) {
  return (0, _entries2.default)(kvs).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (value instanceof Function) {
      // just copy it
      acc[key] = value;
    } else {
      acc[key] = get(value);
    }
    return acc;
  }, {});
};

// Returns a base64 encoded string of the string passed in.
var base64Encode = exports.base64Encode = function base64Encode(toEncode) {
  return Buffer.from(toEncode).toString('base64');
};
var base64Decode = exports.base64Decode = function base64Decode(encoded) {
  return Buffer.from(encoded, 'base64').toString();
};

// A function which returns its first argument.
var nop = exports.nop = function nop(arg) {
  return arg;
};

// Copys the properties and their values of the input object to a new output
// object and returns it.
var filter = exports.filter = function filter(obj) {
  return (0, _entries2.default)(obj).reduce(function (acc, _ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];

    if (v) {
      acc[k] = v;
    }return acc;
  }, {});
};

// Creates a cryptographically random sequence of characters.
var token = exports.token = function () {
  var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = base64Encode;
            _context.next = 3;
            return rand(256);

          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt('return', (0, _context.t0)(_context.t1));

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function token() {
    return _ref5.apply(this, arguments);
  };
}();

// Wraps the crypto.randomBytes API to use promises.
var rand = function rand(size) {
  return new _promise2.default(function (resolve, reject) {
    return _crypto2.default.randomBytes(size, function (err, buf) {
      if (err) {
        reject(err);
      }
      resolve(buf);
    });
  });
};

// A functional way to throw errors. This is useful for throwing errors when
// destructuring an object when a value isn't provided.
var toss = exports.toss = function toss(err) {
  throw err;
};
var required = exports.required = function required(what, foor) {
  return toss(new TypeError(what + ' is a required parameter to ' + foor));
};

var MS = exports.MS = 1;
var SECONDS = exports.SECONDS = 1000 * MS;
var MINUTES = exports.MINUTES = 60 * SECONDS;
var HOURS = exports.HOURS = 60 * MINUTES;


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/utils.js
// module id = 114
// module chunks = 0